var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "v-height-flag" },
      [
        _c(
          "el-card",
          { attrs: { "body-style": { padding: 0 } } },
          [
            _c(
              "el-tabs",
              {
                staticClass: "cr-header-tabs",
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              _vm._l(_vm.tabData, function (item) {
                return _c("el-tab-pane", {
                  key: "id" + item.key,
                  attrs: { label: item.label, name: String(item.key) },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm.activeName === "wps_config"
                  ? _c("cloudfile", { attrs: { rule: _vm.rule } })
                  : _vm.activeName === "yiht_config"
                  ? _c("oneNumber", { attrs: { fromData: _vm.rule } })
                  : _vm.activeName === "storage_config"
                  ? _c("storage")
                  : _c(
                      "div",
                      [
                        _c(
                          "el-scrollbar",
                          { staticStyle: { height: "calc(100vh - 190px)" } },
                          [
                            _vm.fromData
                              ? _c("form-create", {
                                  attrs: {
                                    option: _vm.option,
                                    rule: _vm.fromData.rule,
                                  },
                                  on: { submit: _vm.onSubmit },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }